// extracted by mini-css-extract-plugin
export default {"iconbutton":"iconbutton_iconbutton__o8LdF","btn-small":"iconbutton_btn-small__Ba2og","btn-medium":"iconbutton_btn-medium__WUZEp","btn-large":"iconbutton_btn-large__7I8dq"};